/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_History_Counts_HintInputs */

const cs_ebr_history_counts_hint = /** @type {(inputs: Ebr_History_Counts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počty: nabídky / makléři. Níže jsou položky se změnou.`)
};

const en_ebr_history_counts_hint = /** @type {(inputs: Ebr_History_Counts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Counts: offers / brokers. Items with changes below.`)
};

/**
* | output |
* | --- |
* | "Counts: offers / brokers. Items with changes below." |
*
* @param {Ebr_History_Counts_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_history_counts_hint = /** @type {((inputs?: Ebr_History_Counts_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_History_Counts_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_history_counts_hint(inputs)
	return cs_ebr_history_counts_hint(inputs)
});